import { fork, call, take, put, all } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { unauthorizedAction } from '../actions/authActions'
import {
  getAllModemTypesAction,
  getModemTypeAction,
  createModemTypeAction,
  updateModemTypeAction,
  deleteModemTypeAction,
} from '../actions/modemTypesActions'
import {
  showSuccessMessageAction,
  showErrorMessageAction,
} from '../actions/uiActions'
import api from '../services/api'
import { MESSAGES } from '../constants'
import { pickErrorMessage } from '../utils/helpers'

// modem types have no detail page - creating/editing one goes back to the
// list on the inventory page
const MODEM_TYPES_LIST_PATH = '/inventory/all/modems'

// handlers

function* handleGetAllModemTypesSaga(qs) {
  try {
    const payload = yield call(api.getAllModemTypes, qs)
    yield put(getAllModemTypesAction.success(payload))
  } catch (error) {
    yield put(getAllModemTypesAction.failure(error))
    yield put(showErrorMessageAction(pickErrorMessage(error)))

    if (error.status === 401) {
      yield put(unauthorizedAction())
    }
  }
}

function* handleGetModemTypeSaga(id) {
  try {
    const payload = yield call(api.getModemType, id)
    yield put(getModemTypeAction.success(payload))
  } catch (error) {
    yield put(getModemTypeAction.failure(error))
    yield put(showErrorMessageAction(pickErrorMessage(error)))

    if (error.status === 401) {
      yield put(unauthorizedAction())
    }
  }
}

function* handleCreateModemTypeSaga(modemType) {
  try {
    const payload = yield call(api.createModemType, modemType)

    yield put(createModemTypeAction.success(payload))
    yield put(showSuccessMessageAction(MESSAGES.SUCCESSFULLY_CREATED))
    yield put(push(MODEM_TYPES_LIST_PATH))
  } catch (error) {
    yield put(createModemTypeAction.failure(error))
    yield put(showErrorMessageAction(pickErrorMessage(error)))

    if (error.status === 401) {
      yield put(unauthorizedAction())
    }
  }
}

function* handleUpdateModemTypeSaga(modemType) {
  try {
    const payload = yield call(api.updateModemType, modemType)
    yield put(updateModemTypeAction.success(payload))
    yield put(showSuccessMessageAction(MESSAGES.SUCCESSFULLY_UPDATED))
    yield put(push(MODEM_TYPES_LIST_PATH))
  } catch (error) {
    yield put(updateModemTypeAction.failure(error))
    yield put(showErrorMessageAction(pickErrorMessage(error)))

    if (error.status === 401) {
      yield put(unauthorizedAction())
    }
  }
}

function* handleDeleteModemTypeSaga(id) {
  try {
    const confirmDeletion = yield call(global.confirm, MESSAGES.CONFIRM)
    if (confirmDeletion) {
      yield call(api.deleteModemType, id)
      yield fork(handleGetAllModemTypesSaga, global.location.search)
      yield put(showSuccessMessageAction(MESSAGES.SUCCESSFULLY_DELETED))
    }
  } catch (error) {
    yield put(deleteModemTypeAction.failure(error))
    yield put(showErrorMessageAction(pickErrorMessage(error)))

    if (error.status === 401) {
      yield put(unauthorizedAction())
    }
  }
}

// watchers

function* watchGetAllModemTypesSaga() {
  while (true) {
    const { payload: qs } = yield take(getAllModemTypesAction.REQUEST)
    yield fork(handleGetAllModemTypesSaga, qs)
  }
}

function* watchGetModemTypeSaga() {
  while (true) {
    const { payload } = yield take(getModemTypeAction.REQUEST)
    yield fork(handleGetModemTypeSaga, payload)
  }
}

function* watchCreateModemTypeSaga() {
  while (true) {
    const { payload } = yield take(createModemTypeAction.REQUEST)
    yield fork(handleCreateModemTypeSaga, payload)
  }
}

function* watchUpdateModemTypeSaga() {
  while (true) {
    const { payload } = yield take(updateModemTypeAction.REQUEST)
    yield fork(handleUpdateModemTypeSaga, payload)
  }
}

function* watchDeleteModemTypeSaga() {
  while (true) {
    const { payload } = yield take(deleteModemTypeAction.REQUEST)
    yield fork(handleDeleteModemTypeSaga, payload)
  }
}

function* modemTypesSaga() {
  yield all([
    fork(watchGetAllModemTypesSaga),
    fork(watchGetModemTypeSaga),
    fork(watchCreateModemTypeSaga),
    fork(watchUpdateModemTypeSaga),
    fork(watchDeleteModemTypeSaga),
  ])
}

export {
  modemTypesSaga as default,
  watchGetAllModemTypesSaga,
  watchGetModemTypeSaga,
  watchCreateModemTypeSaga,
  watchUpdateModemTypeSaga,
  watchDeleteModemTypeSaga,
  handleGetAllModemTypesSaga,
  handleGetModemTypeSaga,
  handleCreateModemTypeSaga,
  handleUpdateModemTypeSaga,
  handleDeleteModemTypeSaga,
}
